<template>
    <button v-if="$route.name != 'Dashboard'" ref="component_btn_back"
        class="tw:inline-flex tw:items-center tw:gap-2 tw:px-4 tw:py-2 tw:rounded-full tw:border tw:border-slate-300 tw:bg-transparent tw:text-slate-700 tw:text-xs tw:font-semibold tw:cursor-pointer tw:transition-all tw:hover:bg-slate-900 tw:hover:text-white tw:hover:border-slate-900"
        @click="backPage">
        <i class="fa fa-arrow-circle-left tw:text-sm"></i>
        <span>Regresar</span>
    </button>
</template>

<script>
export default {
    name: 'BackWidget',
    methods: {
        backPage() {
            this.$router.go(-1);
        }
    },
}
</script>